export enum PrimaryScene {
    cooperation = "cooperation",
    design = "design",
    develop = "develop",
    education = "education",
    finance = "finance",
    manufacturing = "manufacturing",
    marketing = "marketing",
    objective = "objective",
    retail = "retail",
    project = "project",
    rd = "rd",
    research = "research",
    testing = "testing",
    operations = "operations",
}
